import { Body1Strong, Caption1 } from '@fluentui/react-components';

import { getLiteratureByline } from '../helpers';
import { TLiteratureContent } from '../types';

type TProps = {
  content: TLiteratureContent | undefined;
};

// Two-line summary used by the citation insert dialog row and the citation
// bubble menu so both surfaces show the same information about a record:
// title (Body1Strong) over a one-line byline (Caption1). Lines wrap rather
// than truncate: verifying the right citation depends on seeing the full
// title, and hover tooltips would hide the most important information.
const LiteratureSummary = ({ content }: TProps) => {
  if (!content) return null;
  const byline = getLiteratureByline(content);

  return (
    <div className="flex flex-col min-w-0 flex-1">
      <Body1Strong className="break-words">{content.title || '(untitled)'}</Body1Strong>
      {byline && <Caption1 className="break-words text-neutral-600">{byline}</Caption1>}
    </div>
  );
};

export default LiteratureSummary;
